//@flow
export default function getFilename(url: string) {
  if (url.startsWith('data:image')) {
    return url;
  }
  return url.split('/').pop();
}
